(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tail-wagging-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__tailWaggingQuizBootstrapped) return;
    window.__tailWaggingQuizBootstrapped = true;

    const SECTION_SELECTOR = '[data-tail-wagging-quiz]';
    const TOTAL_STEPS = 5;

    function getStorage() {
      try {
        return window.sessionStorage;
      } catch (_) {
        return null;
      }
    }

    function parseState(value) {
      if (!value) return null;

      try {
        return JSON.parse(value);
      } catch (_) {
        return null;
      }
    }

    function getDefaultState() {
      return {
        currentStep: 1,
        dogName: '',
        dogSize: '',
        sensitivity: '',
        behavior: '',
        priority: '',
        email: '',
        result: '',
        started: false,
        dialogOpen: false,
        emailSubmitted: false,
        pendingSubmission: false,
      };
    }

    function clampStep(step) {
      if (!Number.isFinite(step)) return 1;
      return Math.min(Math.max(step, 1), TOTAL_STEPS);
    }

    function getPossessive(name) {
      if (!name) return "your dog's";
      return /s$/i.test(name) ? `${name}'` : `${name}'s`;
    }

    function getDogObject(name) {
      return name || 'your dog';
    }

    function resolveResult(state) {
      if (
        state.sensitivity === 'sensitive_stomach' ||
        state.sensitivity === 'grain_free' ||
        state.priority === 'digestion'
      ) {
        return 'B';
      }

      if (state.priority === 'training' || state.behavior === 'training') {
        return 'C';
      }

      return 'A';
    }

    function emitTracking(root, eventName, payload = {}) {
      const detail = {
        event: eventName,
        sectionId: root.dataset.sectionId || '',
        ...payload,
      };

      root.dispatchEvent(
        new CustomEvent(eventName, {
          bubbles: true,
          detail,
        })
      );

      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(detail);
      }
    }

    function initSection(root) {
      if (!(root instanceof HTMLElement)) return;
      if (root.dataset.tailQuizInitialized === 'true') return;

      root.dataset.tailQuizInitialized = 'true';

      const storage = getStorage();
      const storageKey = root.dataset.storageKey || `tail-wagging-quiz-${root.dataset.sectionId || 'default'}`;
      const flowCard = root.querySelector('[data-quiz-flow-card]');
      const stage = root.querySelector('[data-quiz-stage]');
      const results = root.querySelector('[data-quiz-results]');
      const progressLabel = root.querySelector('[data-quiz-progress-label]');
      const progressBar = root.querySelector('[data-quiz-progress-bar]');
      const progressSegments = Array.from(root.querySelectorAll('[data-quiz-progress-segment]'));
      const liveRegion = root.querySelector('[data-quiz-live-region]');
      const formStateNode = root.querySelector('[data-quiz-form-state]');
      const emailForm = root.querySelector('.tw-quiz__email-form');
      const emailInput = root.querySelector('[data-quiz-email]');
      const tagInput = root.querySelector('[data-quiz-tags]');
      const dialog = root.querySelector('[data-quiz-dialog]');
      const launchButtons = Array.from(root.querySelectorAll('[data-quiz-launch]'));
      const launchLabels = Array.from(root.querySelectorAll('[data-quiz-launch-label]'));
      const panels = Array.from(root.querySelectorAll('[data-quiz-step]'));
      const resultPanels = Array.from(root.querySelectorAll('[data-quiz-result]'));
      const focusableHeadings = Array.from(root.querySelectorAll('.tw-quiz__panel-title, .tw-quiz__result-title'));
      const launchHash = String(root.dataset.quizHash || 'quiz')
        .trim()
        .replace(/^#/, '')
        .toLowerCase();

      const savedState = storage ? parseState(storage.getItem(storageKey)) : null;
      const state = {
        ...getDefaultState(),
        ...(savedState || {}),
      };

      let activeResult = '';
      let closeTimer = 0;
      let openFrame = 0;
      let preserveOpenOnUnload = false;
      let userRequestedDialogClose = false;
      const abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
      const listenerOptions = abortController ? { signal: abortController.signal } : undefined;

      function saveState() {
        if (!storage) return;
        storage.setItem(storageKey, JSON.stringify(state));
      }

      function clearState() {
        if (!storage) return;
        storage.removeItem(storageKey);
      }

      function normalizeHashValue(hash) {
        return String(hash || '')
          .trim()
          .replace(/^#/, '')
          .toLowerCase();
      }

      function matchesLaunchHash(hash) {
        if (!launchHash) return false;
        return normalizeHashValue(hash) === launchHash;
      }

      function matchesEmailFormHash(hash) {
        if (!(emailForm instanceof HTMLFormElement) || !emailForm.id) return false;
        return normalizeHashValue(hash) === normalizeHashValue(emailForm.id);
      }

      function isCustomerPostReturn() {
        const params = new URLSearchParams(window.location.search);
        return (
          matchesEmailFormHash(window.location.hash) ||
          (params.get('customer_posted') === 'true' && matchesLaunchHash(window.location.hash))
        );
      }

      function clearLaunchHash() {
        if (!matchesLaunchHash(window.location.hash)) return;
        if (!window.history || typeof window.history.replaceState !== 'function') return;
        window.history.replaceState({}, document.title, `${window.location.pathname}${window.location.search}`);
      }

      function clearEmailFormHash() {
        if (!matchesEmailFormHash(window.location.hash)) return;
        if (!window.history || typeof window.history.replaceState !== 'function') return;
        window.history.replaceState({}, document.title, `${window.location.pathname}${window.location.search}`);
      }

      function getLaunchUrl() {
        return `${window.location.pathname}${window.location.search}#${launchHash}`;
      }

      function setLaunchHash() {
        if (!launchHash || matchesLaunchHash(window.location.hash)) return;
        if (!window.history || typeof window.history.pushState !== 'function') return;
        window.history.pushState({}, document.title, getLaunchUrl());
      }

      function isSamePageLaunchLink(href) {
        if (!href) return false;

        try {
          const url = new URL(href, window.location.href);

          return (
            url.origin === window.location.origin &&
            url.pathname === window.location.pathname &&
            url.search === window.location.search &&
            matchesLaunchHash(url.hash)
          );
        } catch (_) {
          return false;
        }
      }

      function animateDialogOpen() {
        window.clearTimeout(closeTimer);
        window.cancelAnimationFrame(openFrame);
        dialog.classList.remove('is-closing');
        dialog.classList.add('is-opening');

        openFrame = window.requestAnimationFrame(() => {
          dialog.classList.add('is-open');
          dialog.classList.remove('is-opening');
        });
      }

      function finishDialogClose() {
        if (dialog.open) {
          dialog.close();
          return;
        }

        dialog.removeAttribute('open');
        dialog.dispatchEvent(new Event('close'));
      }

      function scheduleHashOpen(options = {}) {
        if (!matchesLaunchHash(window.location.hash)) return false;

        window.requestAnimationFrame(() => {
          openDialog(options);
        });

        return true;
      }

      function updateLaunchButtons() {
        let label = 'Take the quiz';

        if (state.emailSubmitted && state.result) {
          label = 'View your plan';
        } else if (state.started) {
          label = 'Continue quiz';
        }

        launchButtons.forEach((button) => {
          if (!(button instanceof HTMLButtonElement)) return;
          button.setAttribute('aria-label', label);
        });

        launchLabels.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          node.textContent = label;
        });
      }

      function scrollCardTop(card) {
        if (!(card instanceof HTMLElement)) return;
        card.scrollTop = 0;
      }

      function announce(message) {
        if (!(liveRegion instanceof HTMLElement)) return;
        liveRegion.textContent = message;
      }

      function ensureStarted() {
        if (state.started) return;
        state.started = true;
        saveState();
        emitTracking(root, 'quiz_started');
      }

      function updatePersonalization() {
        const cleanName = state.dogName.trim();
        const possessive = getPossessive(cleanName);
        const objectName = getDogObject(cleanName);

        root.querySelectorAll('[data-dog-possessive]').forEach((node) => {
          node.textContent = possessive;
        });

        root.querySelectorAll('[data-dog-object]').forEach((node) => {
          node.textContent = objectName;
        });
      }

      function syncControlsFromState() {
        root.querySelectorAll('[data-quiz-field]').forEach((fieldNode) => {
          if (!(fieldNode instanceof HTMLInputElement)) return;

          const field = fieldNode.dataset.quizField;
          if (!field) return;

          if (fieldNode.type === 'radio') {
            fieldNode.checked = state[field] === fieldNode.value;
            return;
          }

          if (fieldNode.type === 'email') {
            if (!fieldNode.value) {
              fieldNode.value = state.email || fieldNode.value;
            }
            return;
          }

          fieldNode.value = state[field] || '';
        });

        if (emailInput instanceof HTMLInputElement && state.email && !emailInput.value) {
          emailInput.value = state.email;
        }
      }

      function isStepComplete(step) {
        switch (step) {
          case 1:
            return Boolean(state.dogSize);
          case 2:
            return Boolean(state.sensitivity);
          case 3:
            return Boolean(state.behavior);
          case 4:
            return Boolean(state.priority);
          case 5:
            return Boolean(state.email);
          default:
            return false;
        }
      }

      function clearAnswersFromStep(step) {
        if (step <= 1) state.dogSize = '';
        if (step <= 2) state.sensitivity = '';
        if (step <= 3) state.behavior = '';
        if (step <= 4) state.priority = '';

        state.result = step <= 4 ? '' : resolveResult(state);
      }

      function getPanel(step) {
        return panels.find((panel) => Number(panel.dataset.quizStep) === step) || null;
      }

      function clearStepError(panel) {
        if (!(panel instanceof HTMLElement)) return;
        const errorNode = panel.querySelector('[data-step-error]');
        if (!(errorNode instanceof HTMLElement)) return;
        errorNode.hidden = true;
        errorNode.textContent = '';
      }

      function setStepError(panel, message) {
        if (!(panel instanceof HTMLElement)) return;
        const errorNode = panel.querySelector('[data-step-error]');
        if (!(errorNode instanceof HTMLElement)) return;
        errorNode.hidden = false;
        errorNode.textContent = message;
      }

      function focusPanelHeading(panel) {
        if (!(panel instanceof HTMLElement)) return;
        const heading = panel.querySelector('.tw-quiz__panel-title, .tw-quiz__result-title');
        if (!(heading instanceof HTMLElement)) return;
        heading.focus({ preventScroll: true });
      }

      function focusCurrentView() {
        if (state.emailSubmitted && state.result) {
          const activeResultPanel = resultPanels.find((panel) => panel.dataset.quizResult === state.result) || null;
          focusPanelHeading(activeResultPanel);
          return;
        }

        focusPanelHeading(getPanel(state.currentStep));
      }

      function queueFocusAfterDialogOpen() {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;
            focusCurrentView();
          });
        });
      }

      function openDialog(options = {}) {
        if (!(dialog instanceof HTMLDialogElement)) return;

        if (!state.started && !state.emailSubmitted) {
          ensureStarted();
          state.currentStep = 1;
          state.pendingSubmission = false;
          render({ focus: false });
        }

        if (!dialog.open) {
          try {
            if (typeof dialog.showModal === 'function') {
              dialog.showModal();
            } else {
              dialog.setAttribute('open', 'open');
            }
          } catch (_) {
            dialog.setAttribute('open', 'open');
          }
        }

        animateDialogOpen();

        state.dialogOpen = true;
        updateLaunchButtons();
        saveState();

        if (options.focus !== false) {
          queueFocusAfterDialogOpen();
        }
      }

      function closeDialog() {
        if (!(dialog instanceof HTMLDialogElement)) return;

        userRequestedDialogClose = true;
        state.dialogOpen = false;
        updateLaunchButtons();
        saveState();

        window.clearTimeout(closeTimer);
        window.cancelAnimationFrame(openFrame);

        if (!dialog.open) {
          dialog.classList.remove('is-open', 'is-opening', 'is-closing');
          clearLaunchHash();
          userRequestedDialogClose = false;
          return;
        }

        dialog.classList.remove('is-open', 'is-opening');
        dialog.classList.add('is-closing');

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        closeTimer = window.setTimeout(finishDialogClose, reduceMotion ? 1 : 220);
      }

      function preserveDialogStateBeforeUnload() {
        if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;
        preserveOpenOnUnload = true;
        state.dialogOpen = true;
        saveState();
      }

      function validateStep(step) {
        const panel = getPanel(step);
        clearStepError(panel);

        switch (step) {
          case 1:
            if (state.dogSize) return true;
            setStepError(panel, "Please choose your dog's size.");
            panel?.querySelector('input[data-quiz-field="dogSize"]')?.focus();
            return false;
          case 2:
            if (state.sensitivity) return true;
            setStepError(panel, 'Please choose one option.');
            panel?.querySelector('input[data-quiz-field="sensitivity"]')?.focus();
            return false;
          case 3:
            if (state.behavior) return true;
            setStepError(panel, 'Please choose one option.');
            panel?.querySelector('input[data-quiz-field="behavior"]')?.focus();
            return false;
          case 4:
            if (state.priority) return true;
            setStepError(panel, 'Please choose one option.');
            panel?.querySelector('input[data-quiz-field="priority"]')?.focus();
            return false;
          default:
            return true;
        }
      }

      function completeStep(step, options = {}) {
        if (!validateStep(step)) return false;

        emitTracking(root, 'quiz_step_completed', {
          step,
          result_preview: resolveResult(state),
        });

        state.currentStep = clampStep(step + 1);
        state.result = resolveResult(state);
        render(options);

        return true;
      }

      function setProgress(step) {
        if (!(progressBar instanceof HTMLElement)) return;

        progressSegments.forEach((segment, index) => {
          if (!(segment instanceof HTMLElement)) return;
          segment.classList.toggle('is-active', index < step);
        });
      }

      function renderResult(options = {}) {
        if (!(stage instanceof HTMLElement) || !(results instanceof HTMLElement)) return;

        if (flowCard instanceof HTMLElement) {
          flowCard.hidden = false;
          flowCard.classList.remove('tw-quiz__card--email-background-active');
        }

        state.result = resolveResult(state);
        stage.hidden = true;
        results.hidden = false;
        scrollCardTop(flowCard);

        if (progressLabel instanceof HTMLElement) {
          progressLabel.textContent = 'Plan';
        }

        setProgress(TOTAL_STEPS);

        resultPanels.forEach((panel) => {
          if (!(panel instanceof HTMLElement)) return;
          const matches = panel.dataset.quizResult === state.result;
          panel.hidden = !matches;

          if (matches && activeResult !== state.result) {
            activeResult = state.result;
            emitTracking(root, 'quiz_result_viewed', {
              result: state.result,
              dog_size: state.dogSize,
              sensitivity: state.sensitivity,
              behavior: state.behavior,
              priority: state.priority,
            });
            if (options.focus !== false) {
              focusPanelHeading(panel);
            }
            announce('Your personalized plan is ready.');
          }
        });
      }

      function renderStep(options = {}) {
        if (!(stage instanceof HTMLElement) || !(results instanceof HTMLElement)) return;

        if (flowCard instanceof HTMLElement) {
          flowCard.hidden = false;
        }

        stage.hidden = false;
        results.hidden = true;
        activeResult = '';
        scrollCardTop(flowCard);

        const currentStep = clampStep(state.currentStep);
        state.currentStep = currentStep;
        const activePanel = getPanel(currentStep);

        if (flowCard instanceof HTMLElement) {
          flowCard.classList.toggle(
            'tw-quiz__card--email-background-active',
            currentStep === TOTAL_STEPS && activePanel?.classList.contains('tw-quiz__panel--email-has-background')
          );
        }

        if (progressLabel instanceof HTMLElement) {
          progressLabel.textContent = `Step ${currentStep} of ${TOTAL_STEPS}`;
        }

        setProgress(currentStep);

        panels.forEach((panel) => {
          if (!(panel instanceof HTMLElement)) return;
          const matches = Number(panel.dataset.quizStep) === currentStep;
          panel.hidden = !matches;
        });

        if (options.focus !== false) {
          focusPanelHeading(activePanel);
        }
      }

      function render(options = {}) {
        updatePersonalization();
        syncControlsFromState();
        updateLaunchButtons();

        if (state.emailSubmitted && state.result) {
          renderResult(options);
        } else {
          renderStep(options);
        }

        saveState();
      }

      function handleRestoreAfterSubmit() {
        const formSuccess = formStateNode instanceof HTMLElement && formStateNode.dataset.formSuccess === 'true';
        const formError = formStateNode instanceof HTMLElement && formStateNode.dataset.formError === 'true';
        const customerPostReturn = isCustomerPostReturn();

        if ((state.pendingSubmission || customerPostReturn) && formError) {
          state.pendingSubmission = false;
          state.started = true;
          state.dialogOpen = true;
          state.emailSubmitted = false;
          state.currentStep = TOTAL_STEPS;
          setLaunchHash();
          clearEmailFormHash();
          render({ focus: false });
          openDialog({ focus: true });
          return;
        }

        if (state.pendingSubmission || formSuccess || customerPostReturn) {
          state.pendingSubmission = false;
          state.started = true;
          state.dialogOpen = true;
          state.emailSubmitted = true;
          state.result = state.result || resolveResult(state);
          setLaunchHash();
          clearEmailFormHash();
          render({ focus: false });
          openDialog({ focus: true });
          return;
        }

        render({ focus: false });

        if (scheduleHashOpen({ focus: true })) return;

        if (state.dialogOpen) {
          openDialog({ focus: true });
        }
      }

      async function fetchCart() {
        try {
          const cartUrl =
            (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) ||
            `${window.Shopify.routes.root}cart.js`;
          const response = await fetch(cartUrl);

          if (!response.ok) return null;

          if (cartUrl.endsWith('.js')) {
            return response.json();
          }

          const jsonResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
          if (!jsonResponse.ok) return null;
          return jsonResponse.json();
        } catch (_) {
          return null;
        }
      }

      function getCartSectionIds() {
        const ids = new Set();
        document.querySelectorAll('cart-items-component[data-section-id]').forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          if (node.dataset.sectionId) {
            ids.add(node.dataset.sectionId);
          }
        });
        return Array.from(ids);
      }

      async function addToCart(button) {
        if (!(button instanceof HTMLButtonElement)) return;

        const variantId = Number(button.dataset.variantId || '0');
        const productId = button.dataset.productId || '';
        const productTitle = button.dataset.productTitle || '';
        const resultKey = button.dataset.resultKey || state.result;
        const statusNode = button.parentElement?.querySelector('[data-quiz-product-status]');

        if (!variantId) return;

        const originalText = button.textContent || 'Add to cart';
        const sections = getCartSectionIds();
        const cartAddUrl =
          (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) ||
          `${window.Shopify.routes.root}cart/add.js`;

        button.disabled = true;
        button.textContent = 'Adding...';

        if (statusNode instanceof HTMLElement) {
          statusNode.textContent = '';
          delete statusNode.dataset.status;
        }

        try {
          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity: 1,
                },
              ],
              sections: sections.join(','),
            }),
          });

          const data = await response.json();

          if (!response.ok || data.status) {
            const message = data.message || 'We could not add this item right now.';
            if (statusNode instanceof HTMLElement) {
              statusNode.textContent = message;
              statusNode.dataset.status = 'error';
            }
            announce(message);
            button.disabled = false;
            button.textContent = originalText;
            return;
          }

          const cart = await fetchCart();

          button.textContent = 'Added';

          if (statusNode instanceof HTMLElement) {
            statusNode.textContent = 'Added to cart.';
            statusNode.dataset.status = 'success';
          }

          button.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart || undefined,
                sourceId: root.id,
                data: {
                  source: 'product-form-component',
                  itemCount: 1,
                  productId,
                  sections: data.sections || {},
                },
              },
            })
          );

          emitTracking(root, 'quiz_add_to_cart', {
            result: resultKey,
            product_id: productId,
            product_title: productTitle,
          });

          announce(`${productTitle || 'Item'} added to cart.`);

          window.setTimeout(() => {
            button.disabled = false;
            button.textContent = originalText;
          }, 1400);
        } catch (_) {
          if (statusNode instanceof HTMLElement) {
            statusNode.textContent = 'We could not add this item right now.';
            statusNode.dataset.status = 'error';
          }
          announce('We could not add this item right now.');
          button.disabled = false;
          button.textContent = originalText;
        }
      }

      function updateStateFromField(target, field) {
        if (target.type === 'radio') {
          if (!target.checked) return false;
          state[field] = target.value;
        } else if (field === 'dogName') {
          state[field] = target.value.replace(/\s+/g, ' ').trimStart();
        } else {
          state[field] = target.value.trim();
        }

        if (field === 'priority' || field === 'sensitivity' || field === 'behavior') {
          state.result = resolveResult(state);
        }

        if (field === 'email' && tagInput instanceof HTMLInputElement) {
          tagInput.value = `newsletter,tail-wagging-quiz,result-${resolveResult(state).toLowerCase()}`;
        }

        return true;
      }

      function maybeAdvanceAfterSelection(target) {
        if (target.type !== 'radio' || !target.checked) return false;

        const panel = target.closest('[data-quiz-step]');
        const currentStep = Number(panel?.dataset.quizStep || state.currentStep);

        if (currentStep !== state.currentStep || currentStep >= TOTAL_STEPS || !isStepComplete(currentStep)) {
          return false;
        }

        return completeStep(currentStep, { focus: true });
      }

      root.addEventListener(
        'input',
        (event) => {
          const target = event.target;
          if (!(target instanceof HTMLInputElement)) return;

          const field = target.dataset.quizField;
          if (!field) return;

          ensureStarted();

          if (!updateStateFromField(target, field)) return;

          const panel = target.closest('[data-quiz-step]');
          clearStepError(panel);
          updatePersonalization();
          if (maybeAdvanceAfterSelection(target)) return;
          saveState();
        },
        listenerOptions
      );

      root.addEventListener(
        'change',
        (event) => {
          const target = event.target;
          if (!(target instanceof HTMLInputElement)) return;
          const field = target.dataset.quizField;
          if (!field) return;
          ensureStarted();
          if (!updateStateFromField(target, field)) return;
          clearStepError(target.closest('[data-quiz-step]'));
          updatePersonalization();
          if (maybeAdvanceAfterSelection(target)) return;
          saveState();
        },
        listenerOptions
      );

      root.addEventListener(
        'click',
        (event) => {
          const target = event.target;
          if (!(target instanceof Element)) return;

          const launchButton = target.closest('[data-quiz-launch]');
          if (launchButton instanceof HTMLButtonElement) {
            setLaunchHash();
            openDialog({ focus: true });
            return;
          }

          const closeButton = target.closest('[data-quiz-close]');
          if (closeButton instanceof HTMLButtonElement) {
            closeDialog();
            return;
          }

          const backButton = target.closest('[data-quiz-back]');
          if (backButton instanceof HTMLButtonElement) {
            const panel = backButton.closest('[data-quiz-step]');
            const currentStep = Number(panel?.dataset.quizStep || state.currentStep);
            const previousStep = clampStep(currentStep - 1);
            state.currentStep = previousStep;
            state.emailSubmitted = false;
            clearAnswersFromStep(previousStep);
            render({ focus: true });
            return;
          }

          const restartButton = target.closest('[data-quiz-restart]');
          if (restartButton instanceof HTMLButtonElement) {
            Object.assign(state, getDefaultState(), {
              dialogOpen: dialog instanceof HTMLDialogElement && dialog.open,
            });
            clearState();
            render({ focus: true });
            announce('Quiz restarted.');
            return;
          }

          const addToCartButton = target.closest('[data-quiz-add-to-cart]');
          if (addToCartButton instanceof HTMLButtonElement) {
            addToCart(addToCartButton);
          }
        },
        listenerOptions
      );

      function handleExternalLaunchClick(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const launchTrigger = target.closest('[data-quiz-launch]');

        if (launchTrigger instanceof HTMLElement && !root.contains(launchTrigger)) {
          event.preventDefault();
          setLaunchHash();
          openDialog({ focus: true });
          return;
        }

        const anchor = target.closest('a[href]');

        if (!(anchor instanceof HTMLAnchorElement) || !isSamePageLaunchLink(anchor.href)) return;

        event.preventDefault();
        setLaunchHash();
        openDialog({ focus: true });
      }

      if (emailForm instanceof HTMLFormElement) {
        emailForm.addEventListener(
          'submit',
          (event) => {
            ensureStarted();

            if (!emailForm.reportValidity()) {
              event.preventDefault();
              return;
            }

            if (!(emailInput instanceof HTMLInputElement)) return;

            state.email = emailInput.value.trim();
            state.result = resolveResult(state);
            state.dialogOpen = true;
            state.emailSubmitted = true;
            state.pendingSubmission = true;
            state.currentStep = TOTAL_STEPS;

            if (tagInput instanceof HTMLInputElement) {
              tagInput.value = `newsletter,tail-wagging-quiz,result-${state.result.toLowerCase()}`;
            }

            saveState();
            emitTracking(root, 'quiz_email_submitted', {
              result: state.result,
            });
          },
          listenerOptions
        );
      }

      focusableHeadings.forEach((heading) => {
        if (!(heading instanceof HTMLElement)) return;
        heading.tabIndex = -1;
      });

      if (dialog instanceof HTMLDialogElement) {
        dialog.addEventListener(
          'cancel',
          (event) => {
            event.preventDefault();
            closeDialog();
          },
          listenerOptions
        );

        dialog.addEventListener(
          'close',
          () => {
            const shouldCloseForUser = userRequestedDialogClose && !preserveOpenOnUnload;
            userRequestedDialogClose = false;
            window.clearTimeout(closeTimer);
            window.cancelAnimationFrame(openFrame);
            dialog.classList.remove('is-open', 'is-opening', 'is-closing');

            if (shouldCloseForUser) {
              state.dialogOpen = false;
              updateLaunchButtons();
              saveState();
              clearLaunchHash();
              return;
            }

            state.dialogOpen = preserveOpenOnUnload || state.dialogOpen || matchesLaunchHash(window.location.hash);
            updateLaunchButtons();
            saveState();
          },
          listenerOptions
        );
      }

      window.addEventListener('beforeunload', preserveDialogStateBeforeUnload, listenerOptions);
      window.addEventListener('pagehide', preserveDialogStateBeforeUnload, listenerOptions);

      document.addEventListener('click', handleExternalLaunchClick, listenerOptions);

      window.addEventListener(
        'hashchange',
        () => {
          scheduleHashOpen({ focus: true });
        },
        listenerOptions
      );

      window.addEventListener(
        'pageshow',
        () => {
          preserveOpenOnUnload = false;
          scheduleHashOpen({ focus: false });
        },
        listenerOptions
      );

      document.addEventListener(
        'shopify:section:unload',
        (event) => {
          const target = event.target;
          if (!(target instanceof Element) || !target.contains(root)) return;
          window.clearTimeout(closeTimer);
          window.cancelAnimationFrame(openFrame);
          abortController?.abort();
        },
        listenerOptions
      );

      handleRestoreAfterSubmit();
    }

    function boot(root = document) {
      root.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
        initSection(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot());
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      if (target.matches(SECTION_SELECTOR)) {
        initSection(target);
        return;
      }

      boot(target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
